import { pipe, prop, sortBy } from 'remeda';

import { setSeverity } from './setSeverity';

import type { Deviation } from 'API';

export const getOldestDeviation = (deviations: Deviation[]) => {
    const severity = setSeverity(deviations);

    const sortedDeviations = pipe(Object.values(deviations), (_: Deviation[]) =>
        sortBy(
            _.filter(deviation => deviation.severity === severity),
            [prop('sentAt'), 'desc']
        )
    );

    return sortedDeviations[0]?.sentAt ?? String(new Date());
};
